// Glass effect for the hall's patio door (moved here from the retired garden renderer —
// Task 17 of the farm spec). Soft diagonal highlights drawn over
// whatever the door shows so the panes read as glass, not as a hole in the wall.
// NOTE: keep this file free of `config.js` / Phaser imports — config.js reads
// `import.meta.env`, which does not exist under node, and `node --test` covers the maths.

// Fractions of the pane width: `at` = where the streak's bottom-left corner sits,
// `width` = streak width, `alpha` = peak opacity of the white gradient.
export const GLASS_STREAKS = [
  { at: 0.12, width: 0.30, alpha: 0.28 },
  { at: 0.58, width: 0.14, alpha: 0.16 },
];
// How far (fraction of the pane width) the streak's top edge is shifted right of its
// bottom edge — the "lean" of a reflection on a pane seen slightly from the side.
export const GLASS_STREAK_LEAN = 0.85;

// Parallelogram (4 points, world px) for one streak: bottom edge on the pane bottom,
// top edge on the pane top, shifted right by GLASS_STREAK_LEAN·w.
export function streakPolygon(rect, streak) {
  const x0 = rect.x + rect.w * streak.at;
  const w = rect.w * streak.width;
  const lean = rect.w * GLASS_STREAK_LEAN;
  const top = rect.y, bottom = rect.y + rect.h;
  return [
    { x: x0, y: bottom },
    { x: x0 + w, y: bottom },
    { x: x0 + lean + w, y: top },
    { x: x0 + lean, y: top },
  ];
}
